module.exports = __webpack_public_path__ + "img/square.svg";